import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';

const messages = defineMessages({
  REQUEST_RECIEVED: {
    id: 'PasswordRequestMessageSuccess.REQUEST_RECIEVED',
    defaultMessage: 'Ihre Anfrage ist eingegangen',
  },
  MAIL_RESET_PASSWORD: {
    id: 'PasswordRequestMessageSuccess.MAIL_RESET_PASSWORD',
    defaultMessage: 'Der Benutzer hat eine Nachricht mit Instruktionen zur Rücksetzung seines Passwortes erhalten.',
  },
  BACK: {
    id: 'PasswordRequestMessageSuccess.BACK',
    defaultMessage: 'Zurück',
  },
});

function PasswordRequestMessageSuccess({ params: { companyId, userId }, intl: { formatMessage } }) {
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '700px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={`/company/${companyId}/user/${userId}/`} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.REQUEST_RECIEVED)}
            </h2>
          </div>
          
          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
            <div style={{ padding: '16px', backgroundColor: 'rgba(59, 130, 246, 0.1)', borderLeft: '4px solid #3b82f6', borderRadius: '8px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <i className="fa fa-info-circle" style={{ color: '#3b82f6', fontSize: '20px', marginTop: '2px' }} />
              <div>
                <p style={{ margin: 0, color: 'var(--text-color)', fontSize: '14px', fontWeight: '500' }}>
                  {formatMessage(messages.MAIL_RESET_PASSWORD)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
   </div>
  );
}

export default injectIntl(PasswordRequestMessageSuccess);
